/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var TagType;
(function (TagType) {
    TagType["Account"] = "ACCOUNT";
    TagType["Dimension"] = "DIMENSION";
    TagType["Group"] = "GROUP";
    TagType["Table"] = "TABLE";
})(TagType || (TagType = {}));
export function TagTypeFromJSON(json) {
    return TagTypeFromJSONTyped(json, false);
}
export function TagTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TagTypeToJSON(value) {
    return value;
}
